import axios from "axios";
import { experimentsApiPrefix } from "../../paths";
import { config } from "../../config";

const END_POINT: string = `${experimentsApiPrefix}/anonymous`;

export interface AnonymousFeatureFlagStatus {
  id: string;
  variant: string;
}

export interface AnonymousExperimentsResponse {
  featureFlags: Array<AnonymousFeatureFlagStatus>;
}

export const fetchAnonymousExperiments = (): Promise<AnonymousExperimentsResponse> =>
  axios
    .put<AnonymousExperimentsResponse>(END_POINT, {}, { baseURL: config.baseURL })
    .then((res) => res.data);
